import React from 'react';

// Shared pieces for every screen (criteria in docs/diseno.md): one page header,
// and the same loading, empty and error states everywhere, in Spanish, with
// an action when there is something to do.

const muted = { fontSize: 13, color: 'var(--globant-muted)' };

/** Title of a page: what it is, a short line on what it is for, and its main actions on the right. */
export function PageHeader({ icon, title, area, subtitle, actions }) {
  return (
    <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap', marginBottom: 12 }}>
      <div style={{ minWidth: 0 }}>
        {area && <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase', color: 'var(--globant-muted)' }}>{area}</div>}
        <h1 style={{ margin: 0, fontSize: 22, lineHeight: 1.25, fontWeight: 700, textWrap: 'balance' }}>{icon && <span aria-hidden="true">{icon} </span>}{title}</h1>
        {subtitle && <p style={{ ...muted, margin: '4px 0 0', maxWidth: 680 }}>{subtitle}</p>}
      </div>
      {actions && <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>{actions}</div>}
    </header>
  );
}

export function LoadingState({ text = 'Cargando…' }) {
  return <div role="status" aria-live="polite" style={{ ...muted, padding: '16px 0', display: 'flex', alignItems: 'center', gap: 8 }}><span className="spinner" style={{ width: 14, height: 14, borderWidth: 2 }} aria-hidden="true" />{text}</div>;
}

/** Nothing yet: say what will appear and how to add the first one. */
export function EmptyState({ title, children, action }) {
  return (
    <div style={{ padding: '20px 16px', border: '1px dashed var(--globant-border)', borderRadius: 10, textAlign: 'center', display: 'grid', gap: 8, justifyItems: 'center' }}>
      <b style={{ fontSize: 14 }}>{title}</b>
      {children && <div style={{ ...muted, maxWidth: 520 }}>{children}</div>}
      {action}
    </div>
  );
}

/** What went wrong and how to fix it; a retry when it makes sense. */
export function ErrorState({ message, onRetry }) {
  return (
    <div role="alert" style={{ padding: 12, borderRadius: 10, border: '1px solid rgba(248,113,113,0.4)', background: 'rgba(248,113,113,0.08)', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', fontSize: 13 }}>
      <span>{message || 'No se pudo completar. Vuelve a intentarlo.'}</span>
      {onRetry && <button type="button" className="action-btn" onClick={onRetry}>Reintentar</button>}
    </div>
  );
}
